import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type CreatePdpV1PortfoliosPortfolioIdPdpsPostData,
  type CreatePdpV1PortfoliosPortfolioIdPdpsPostError,
  type CreatePdpV1PortfoliosPortfolioIdPdpsPostResponse,
  createPdpV1PortfoliosPortfolioIdPdpsPost,
} from '../../generated';

export type CreatePdpMutationVariables = CreatePdpV1PortfoliosPortfolioIdPdpsPostData['path'] &
  CreatePdpV1PortfoliosPortfolioIdPdpsPostData['body'];

export type CreatePdpMutation = CreatePdpV1PortfoliosPortfolioIdPdpsPostResponse;

export const useCreatePdpMutation = <TError = CreatePdpV1PortfoliosPortfolioIdPdpsPostError, TContext = unknown>(
  options?: Omit<
    UseMutationOptions<CreatePdpMutation, TError, CreatePdpMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<CreatePdpMutation, TError, CreatePdpMutationVariables, TContext>({
    mutationKey: ['CreatePdp'],
    mutationFn: async ({ portfolio_id, ...body }: CreatePdpMutationVariables) => {
      const { data } = await createPdpV1PortfoliosPortfolioIdPdpsPost({
        path: { portfolio_id },
        body,
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useCreatePdpMutation.fetcher = (
  { portfolio_id, ...body }: CreatePdpMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await createPdpV1PortfoliosPortfolioIdPdpsPost({
      path: { portfolio_id },
      body,
      throwOnError: true,
    });
    return data;
  };
};
